let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    // Isolate each subscriber. Without this, one subscriber throwing synchronously
    // aborts the .map(), so every LATER subscriber is skipped and the throw escapes
    // to the publisher — e.g. a null-deref in a 'cart-update' listener would derail
    // product-form's add-to-cart success path into its error fallback, leaving the
    // cart drawer unopened. A broken listener should not break the cart.
    const promises = subscribers[eventName].map((callback) => {
      try {
        return callback(data);
      } catch (error) {
        console.error(`pubsub: subscriber for "${eventName}" threw`, error);
        return undefined;
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
